import React from 'react';
import ReactDOM from 'react-dom/client';
import { Workbox } from 'workbox-window';
import './i18n';
import './App.css';
import App from './App';
import AdminApp from './admin/App';
import ErrorBoundary from './ErrorBoundary';

// Service Worker Registrierung - NUR in Production
const isProduction = process.env.NODE_ENV === 'production';

if ('serviceWorker' in navigator) {
  if (isProduction) {
    // PROD: Service Worker registrieren
    window.addEventListener('load', () => {
      const wb = new Workbox('/sw.js');

      // Prüfe auf Updates
      wb.addEventListener('waiting', () => {
        console.log('[Service Worker] Neue Version verfügbar');
        // Update wird in App.jsx behandelt
      });

      // Service Worker aktiviert
      wb.addEventListener('controlling', () => {
        console.log('[Service Worker] Neue Version aktiv');
        // Seite wird nur neu geladen, wenn keine laufende Messung vorhanden ist
        const hasRunningMeasurement = localStorage.getItem('stoppuhr_isRunning') === 'true';
        if (!hasRunningMeasurement) {
          window.location.reload();
        }
      });

      // Registriere Service Worker
      wb.register().then((registration) => {
        console.log('[Service Worker] Registriert:', registration);

        // Prüfe ob Service Worker aktiv ist
        if (registration.active) {
          console.log('[Service Worker] Aktiv und bereit für Offline-Modus');
        }

        // Prüfe regelmäßig auf Updates (alle 60 Sekunden)
        setInterval(() => {
          registration.update();
        }, 60000);
      }).catch((error) => {
        console.error('[Service Worker] Registrierung fehlgeschlagen:', error);
        // WICHTIG: Auch ohne Service Worker sollte die App funktionieren
        console.warn('[Service Worker] App läuft ohne Service Worker - Offline-Modus möglicherweise eingeschränkt');
      });
    });
  } else {
    // DEV: Alle Service Worker Registrierungen entfernen
    window.addEventListener('load', () => {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister();
          console.log('[DEV] Service Worker entfernt:', registration.scope);
        });
      });
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
const isAdminPath = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');
root.render(
  <ErrorBoundary>
    {isAdminPath ? <AdminApp /> : <App />}
  </ErrorBoundary>
);

